export enum TrackType {
  Audio = 'audio',
  Video = 'video',
}
